import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import Textfield from "../textfield";

class Stepper extends React.Component {
  constructor(props) {
    super(props);
    this.onIncrease = this.onIncrease.bind(this);
    this.onDecrease = this.onDecrease.bind(this);
  }

  onIncrease() {
    this.props.onChange((parseInt(this.props.value) || 0) + 1);
  }

  onDecrease() {
    this.props.onChange((parseInt(this.props.value) || 0) - 1);
  }

  render() {
    const { value = 0, onChange, className, ...props } = this.props;

    const prefixCls = "stepper";

    const componentCls = classnames(prefixCls, className);

    const buttonCls = `${prefixCls}__button`;
    const buttonWrapperCls = `${prefixCls}__buttons`;
    const inputCls = `${prefixCls}__input`;

    return (
      <div className={componentCls}>
        <Textfield
          className={inputCls}
          type="number"
          value={value}
          onChange={onChange}
          {...props}
        />
        <div className="stepper__buttons-wrapper">
          <div className={buttonWrapperCls}>
            <button
              type="button"
              className={buttonCls}
              onMouseDown={this.onIncrease}
              aria-label="Increase"
            >
              +
            </button>
            <button
              type="button"
              className={buttonCls}
              onMouseDown={this.onDecrease}
              aria-label="Decrease"
            >
              -
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Stepper.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Stepper;



// WEBPACK FOOTER //
// ./casper/sass/components/stepper/stepper.js